import React from 'react';

const InputGroup = ({ children }) => {
    return <div className={'pnt-input--group'}>{children}</div>;
};

export default InputGroup;
